import FadeView from './fade_view';

export default FadeView;
